import { createSlice } from '@reduxjs/toolkit';

const initialState = {};

export const photoReducer = createSlice({
  name: 'photoSlice',
  initialState,
  reducers: {},
});

// export const {} = photoReducer.actions;
export default photoReducer.reducer;
